<div class="container">
  <div class="row ">
    <div class="col-sm-12">
      <h4>Mitarbeiter</h4>
    </div>
  </div>
  <div class="row ">
    <div class="col-sm-12">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef> # </th>
          <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
            {{i+1}}
          </td>
        </ng-container>
        <ng-container matColumnDef="ID">
          <th mat-header-cell *matHeaderCellDef> ID </th>
          <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
            {{element.internalId}}
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let element" class="mat-column"> {{element.person.displayName}} </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> E-Mail </th>
          <td mat-cell *matCellDef="let element" class="mat-column">
            {{((element.email != '') ? element.email : '/')}}
          </td>
        </ng-container>
        <ng-container matColumnDef="mobile">
          <th mat-header-cell *matHeaderCellDef> Telefon </th>
          <td mat-cell *matCellDef="let element" class="mat-column">
            {{((element.mobile != '') ? element.mobile : '/')}}
          </td>
        </ng-container>
        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef> Rolle </th>
          <td mat-cell *matCellDef="let element" class="mat-column">
            <mat-chip-set>
              <mat-chip class="primaryChip" selected>
                {{element.account.role.displayName}}
              </mat-chip>
            </mat-chip-set>
          </td>
        </ng-container>
        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let element" class="mat-column">
            <mat-chip-set>
              <mat-chip class="primaryChip" selected *ngIf="element.account.state == 'ACTIVE'">
                {{element.account.state | translateState}}
              </mat-chip>
              <mat-chip class="accentChip" selected *ngIf="element.account.state != 'ACTIVE'">
                {{element.account.state | translateState}}
              </mat-chip>
            </mat-chip-set>
          </td>
        </ng-container>
        <ng-container matColumnDef="partnerMailRecipient">
          <th mat-header-cell *matHeaderCellDef> Partnermails </th>
          <td mat-cell *matCellDef="let element" class="mat-column">
            <mat-chip-set>
              <mat-chip class="accentChip" selected *ngIf="!element.partnerMailRecipient">
                <mat-icon>close</mat-icon>
              </mat-chip>
              <mat-chip class="primaryChip" selected *ngIf="element.partnerMailRecipient">
                <mat-icon>check</mat-icon>
              </mat-chip>
            </mat-chip-set>
          </td>
        </ng-container>
        <ng-container matColumnDef="menu">
          <th mat-header-cell *matHeaderCellDef class="mat-column">
            Aktion
          </th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu" color="accent">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item [routerLink]="['edit', element.publicId]">
                <span>Bearbeiten</span>
              </button>
              <button mat-menu-item (click)="changeState(element)">
                <span>Status ändern</span>
              </button>
              <button mat-menu-item (click)="  openResetPassword(element)">
                <span>Passwort zurücksetzen</span>
              </button>
              <button mat-menu-item (click)="deleteMember(element)">
                <span>Löschen</span>
              </button>
            
              <button mat-menu-item (click)="changeRole(element)">
                <span>Berechtigung ändern</span>
              </button>
              <button mat-menu-item (click)="activateMail(element,true)" [disabled]="element.partnerMailRecipient">
                <span>Partnermails aktivieren</span>
              </button>
              <button mat-menu-item (click)="activateMail(element,false)" [disabled]="!element.partnerMailRecipient">
                <span>Partnermails deaktivieren</span>
              </button>



            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
      </table>
      <span *ngIf="dataSource?.data.length === 0" class="emptyTableState">Keine passenden Einträge gefunden...</span>
    </div>
  </div>
</div>

<button class="fabAddBtnBottomRight" mat-fab color="accent" [routerLink]="['add']">
  <mat-icon>add</mat-icon>
</button>